import { 
  ChangeDetectorRef,
  Component, 
  ElementRef, 
  EventEmitter, 
  Input, 
  Output, 
  ViewChild
} from '@angular/core';
import { Customer, CustomerNote, CustomerNoteModel, CustomerNoteServiceProxy, CustomerServiceProxy } from '../../../../../shared/service-proxies/event-service-proxy';
import { NoteActionEventModel, NoteActions, NoteModel } from '../../../../data/common/note.dataclass';
import { takeUntil } from 'rxjs';
import { DestroyService } from '../../../../services/destroy/destroy.service';
import { ErrorService } from '../../../../services/error/error.service';
import { ModalService } from '../../../../services/modal/modal.service';

@Component({
    selector: 'app-comments-card',
    templateUrl: './comments-card.component.html',
    styleUrl: './comments-card.component.scss',
    standalone: false
})
export class CommentsCardComponent {
  @Input() customerId?: string = '';
  @Output() commentsUpdated = new EventEmitter<boolean>();
  refreshTrigger: boolean = false;
  textEdited: boolean = false;
  shouldScroll: boolean = true;

  isEditing: boolean = false;

  customerNote: CustomerNote = new CustomerNote;
  constructor(public modalService: ModalService, private errorService: ErrorService, private _customerService: CustomerServiceProxy, private destroyService: DestroyService, private _customerNoteService: CustomerNoteServiceProxy) {}
  commentsListHeight: number;
  selectedNote: CustomerNoteModel = new CustomerNoteModel();  
  deletedComment: boolean = false;

  @ViewChild('commentsContainer') commentsContainer!: ElementRef;
  /**
   * Событие на клик по кнопке "Редактировать" в списке ноутов
   * @param note Ноут, по которому кликнули "Редактировать"
   */
  onEditClick(note: CustomerNoteModel|null) {
    this.selectedNote = note;
    this.isEditing = true;
    this.onCardHeightChange(217.2)
  }
  onDeleteClick(note: CustomerNoteModel | null) {
    this.selectedNote = note;
  }

  onTextAreaEvent(data: NoteActionEventModel) {
    if (data.action == NoteActions.create) {
      this.createNote(data.note);
    } else {
      this.updateNote(data.note);
    }
  }
  onEditClose() {
    this.isEditing = false;
    this.selectedNote = new CustomerNoteModel();
    this.onCardHeightChange(304);
  }
  updateNote(note: NoteModel) {
    if (!note.text.trim()) {
      this.openModal('clearNote');
      return;
    }

    this._customerNoteService.update(this.selectedNote.id, note.text).pipe(takeUntil(this.destroyService.onDestroy$)).subscribe((res) => {
      this.refreshTrigger = !this.refreshTrigger;
      this.isEditing = false;
      this.shouldScroll = false;
      this.onCardHeightChange(304);
    }, error => {
      this.errorService.handleError(error, 'Не удалось редактировать комментарий. Попробуйте позже.');
    })
  }
  deleteNote() {
    console.log(this.selectedNote.id);
    
    this._customerNoteService.delete(this.selectedNote.id)
     .pipe(takeUntil(this.destroyService.onDestroy$))
     .subscribe(() => {
       this.refreshTrigger = !this.refreshTrigger;
       this.isEditing = false;
       this.shouldScroll = false;
       this.onCardHeightChange(304);
       this.deletedComment = true; 
     }, error => {
       this.errorService.handleError(error, 'Не удалось удалить комментарий. Попробуйте позже.');
     });
  }
  createNote(note: NoteModel) {
    const body = new CustomerNote();
    body.text = note.text;
    // TODO Add files
    this._customerService.createNote(this.customerId, body)
      .pipe(takeUntil(this.destroyService.onDestroy$)).subscribe((res) => {
        this.refreshTrigger = !this.refreshTrigger;
        this.isEditing = false;
        this.scrollToBottom(!event);
      }, error => {
        this.errorService.handleError(error, 'Не удалось добавить комментарий. Попробуйте позже.');
      });
  }
  onCommentsChanged(event: boolean) {
    this.refreshTrigger = !this.refreshTrigger;
    this.isEditing = false; 
  }
  onEditEvent(event: boolean) {
    this.isEditing = event;
  }
  onCommentsEdit(event: boolean) {
    this.refreshTrigger = !this.refreshTrigger;
  }

  scrollToBottom(event: boolean) {
    if (this.shouldScroll && this.commentsContainer?.nativeElement) {
      setTimeout(() => {
        this.commentsContainer.nativeElement.scrollTo({
        top: this.commentsContainer.nativeElement.scrollHeight,
        behavior: event ? 'auto' : 'smooth'
      });
      })
    }
  }

  onCardHeightChange(height: number) {
    this.commentsListHeight = height;
  }

  openModal(popup: string) {
    this.modalService.openModal(popup);
  }

}
